import horizon from "../images/horizon.manifest.js";
import emarsys from "../images/emarsys.manifest.js";

import deepMerge from "./utils/deep-merge.js";

const imageConfigs = {
  horizon,
  emarsys,
};

const excludedKeys = ["name", "extend"];
const imageSets = {};

for (const [name, imageConfig] of Object.entries(imageConfigs)) {
  const imageTypes = [];

  for (const imageConfigKey of Object.keys(imageConfig)) {
    if (!excludedKeys.includes(imageConfigKey)) {
      const baseImage = imageConfig.extend?.[imageConfigKey] || {};

      imageTypes[imageConfigKey] = deepMerge(baseImage, imageConfig[imageConfigKey] || {});
    }
  }

  imageSets[name] = {
    name: imageConfig.name,
    ...imageTypes,
  };
}

export default imageSets;
